﻿import React, { useContext } from 'react';
import Context, { context_type } from '@Util/Context';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Image from '@Elements/ImageElements/Image';
import { current_intime_version } from '@Util/GlobalValues';
import { Icon_Close } from '@Elements/ImageElements/Icons';
 
export default function InTime_Logo(): JSX.Element {
    const [t] = useTranslation();
    const { set_sidebar_visible }: context_type = useContext(Context);

    return (
        <div className="Side_Navigation_Top">
            <Link
                to="/"
                onClick={() => set_sidebar_visible(false)}
                className="Side_Navigation_Top_Logo"
                aria-label={t('Aria.GoToStartpage')}
                title={t('Hover.GoToStartpage')}
            >
                <Image
                    imageSrc="/InTime/Templates/Images/Initiva_InTime_Logo.svg"
                    imageAlt="InTime Logo"
                    aspectRatio="160/50"
                />
            </Link>
            <aside className="Side_Navigation_Top_VersionControl">
                <p className="Normal Normal_Small">{`Version: ${current_intime_version}`}</p>
            </aside>
            <button
                type="button"
                className="Side_Navigation_Top_Menu_Toggle"
                onClick={() => set_sidebar_visible(false)}
                aria-label={t('Aria.CloseSidebar')}
            >
                <Icon_Close />
            </button>
        </div>
    );
}